import React from 'react'

const Edit2Icon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" fill="none">
            <path d="M11.9994 6.66668L9.3327 4.00001M1.66602 14.3333L3.92226 14.0826C4.19792 14.052 4.33575 14.0367 4.46458 13.995C4.57888 13.958 4.68765 13.9057 4.78794 13.8396C4.90099 13.765 4.99905 13.667 5.19517 13.4709L13.9994 4.66668C14.7357 3.9303 14.7357 2.73639 13.9994 2.00001C13.263 1.26363 12.0691 1.26363 11.3327 2.00001L2.5285 10.8042C2.33238 11.0003 2.23432 11.0984 2.15977 11.2114C2.09364 11.3117 2.04136 11.4205 2.00436 11.5348C1.96265 11.6636 1.94734 11.8014 1.91671 12.0771L1.66602 14.3333Z" stroke="currentColor" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />            
        </svg>
    )
}

export default Edit2Icon
